module.exports = __webpack_public_path__ + "static/img/72.36d472d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/72.png
// module id = N12A
// module chunks = 0